/**
 * Forms are rendered using draft-js, this abstracts away the draft-js format
 * so you only need to pass in a state object which is a key map of fields to
 * field properties. And an array of which form's keys you want to render.
 */

import PropTypes from 'prop-types'
import React, { Component } from 'react'
import createEventSync from './../lib/createEventSync'

class FormsRenderer extends Component {

	/*static contextTypes = {
		store: React.PropTypes.object,
	};*/

	static propTypes = {

		/**
		 * The product state, expects a key value map where the key is the field
		 * key and the value is a state object.
		 */
		screenState: PropTypes.object,

	};

	state = {};

	onStateChange = (newScreenState, newRenderedFields, formKey) => {
		const { getScreenState, renderedForms, onStateChange } = this.props

    var screenState = getScreenState()
		newScreenState = Object.assign({}, screenState, newScreenState)
		// Update the form's layout with the new fields if the fields have changed

    if (typeof process != 'undefined' && process.env.NODE_ENV != 'production'){
      // Check all newLayoutKeys are pages
      newRenderedFields.forEach(key => {
        if (newScreenState[key].type == 'form' || newScreenState[key].type == 'page')
          throw new Error(`The list of new layout keys includes a key that is a
            a page or form. It's likely that a child onStateChange call was bypassed.
            It was expecting only fields`
            .replace(/\s+/g, ' '))
      })
    }

		if (newRenderedFields != newScreenState[formKey]['layout']){
			newScreenState[formKey]['layout'] = newRenderedFields
		}

		onStateChange(newScreenState, renderedForms)

	};

  onDropMultiEvents = (...args) => {
    // We only care if one drop was successful
    var successDropEvents = args.find(args => args[0] == true)
    if (successDropEvents)
      return this.props.onDrop(...successDropEvents)
    return this.props.onDrop(false)
  }

	render = () => {
		var {
			className,
			FormRenderer,
			FieldsRenderer,
			screenState,
			renderedForms,
      onDrop,
			...otherProps,
    } = this.props

    // This allows us to group the many page onDrop handlers together
    // into one onDrop handler so we can do multi page transfer of controls
    // TODO: Potential memory leak?
    var createEventHandler = createEventSync(this.onDropMultiEvents)

		return <div className={className}>
			{renderedForms.map(key => <FieldsRenderer
				{...otherProps}
				screenState={screenState}
				renderedForms={renderedForms}
				renderedForm={key}
				renderedFields={screenState[key]['layout']}
				key={key}
				blockKey={key}
				onStateChange={(newScreenState, renderedFields) =>
					this.onStateChange(newScreenState, renderedFields, key)}
        onDrop={createEventHandler()}
			/>)}
		</div>
	}

}


export default FormsRenderer



// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/FormsRenderer/FormsRenderer.js